import { ACTIVE_UPI_IDS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const activeUpiIds = () => {
  return apiInstance.get(ACTIVE_UPI_IDS);
};
